import { render } from "./IndicatorBlock.vue?vue&type=template&id=49656bf4"
import script from "./IndicatorBlock.vue?vue&type=script&lang=js"
export * from "./IndicatorBlock.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__